var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpecialBonus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18309"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18306"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Solid / Interface /Settings-alt"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 1",
    d: "m9.482 19.78-2.477-2.562H3.5a.723.723 0 0 1-.722-.722v-3.5L.22 10.52a.722.722 0 0 1 0-1.038l2.562-2.476V3.5a.724.724 0 0 1 .718-.718H7L9.482.22a.722.722 0 0 1 1.038 0l2.475 2.562h3.5a.723.723 0 0 1 .722.723v3.5l2.563 2.477a.722.722 0 0 1 0 1.038l-2.562 2.475v3.5a.723.723 0 0 1-.722.722h-3.5L10.52 19.78a.722.722 0 0 1-1.038 0z",
    transform: "translate(.999 1.001)",
    style: {
      fill: "none",
      stroke: "#1bc47d",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.122.141a.473.473 0 0 1 0 .682l-4.629 4.5a.506.506 0 0 1-.7 0L.145 2.752a.473.473 0 0 1 0-.682.506.506 0 0 1 .7 0L3.141 4.3 7.42.141a.506.506 0 0 1 .702 0z",
    transform: "translate(6.632 8.508)",
    style: {
      fill: "#8c8d99",
      stroke: "#8c8d99"
    },
    "data-name": "Check"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialBonus);
export default __webpack_public_path__ + "static/media/special-bonus.90c8de0320f9c3d901a5ae649968e7d5.svg";
export { ForwardRef as ReactComponent };